import { render, staticRenderFns } from "./search-comp.vue?vue&type=template&id=7d48050f"
import script from "./search-comp.vue?vue&type=script&lang=js"
export * from "./search-comp.vue?vue&type=script&lang=js"
import style0 from "./search-comp.vue?vue&type=style&index=0&id=7d48050f&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports